import React from "react";

export default function RightArrowPoint({ color = "currentColor", size = "15", className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      stroke={color}
      height={size}
      viewBox="0 0 48 48"
      className={className}
    >
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        d="m19 12l12 12l-12 12"
      />
    </svg>
  );
}
